import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FormatBytes from '../FormatBytes';
import Radio from '../Radio';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import themeVariables from '~/shared/themeVariables';

@withI18next()
class AssetsSize extends React.PureComponent {
  isFirstIndexPremium(checkedItem, premiumAssets) {
    return (
      premiumAssets.filter(
        (item, index) => item.type == checkedItem.type && index == 0,
      ).length > 0
    );
  }

  render() {
    const { assets, onSelectItem, profile, t, lng } = this.props;
    // const premiumAssets = assets.filter(
    //   (item) => item.price && item.price.with_tax !== 0,
    // );

    return (
      <div className="ac-assets-size">
        {assets.map((item, index) => {
          const dataType = item.type.split(',');
          return (
            <React.Fragment key={index}>
              <div
                className={`assets-size-item ${
                  item.active && 'assets-size-item-active'
                }`}
                onClick={() => {
                  onSelectItem(item, index);
                }}
              >
                <Radio checked={item.active || false} groupName="assetsSize" />
                {dataType.map((item) => (
                  <div key={item} className={`type-item ${Config.serviceType}`}>
                    {item}
                  </div>
                ))}
                {!Config.isIllustAC() && (
                  <>
                    {item.width && (
                      <div className="size-item">{`${item.width} x ${item.height} px`}</div>
                    )}
                    <div className="asset-price">
                      {(item.price && item.price.with_tax === 0) ||
                      profile.role === 'premium' ? (
                        <b>FREE</b>
                      ) : (
                        <b>
                          {item.price.with_tax}
                          <FontAwesomeIcon
                            style={{ width: 14, marginLeft: 4 }}
                            icon={faDollarSign}
                          />
                        </b>
                      )}
                    </div>
                  </>
                )}
              </div>
              {Config.isIllustAC() && index < assets.length - 1 && (
                <span className="vertical-line" />
              )}
            </React.Fragment>
          );
        })}
        <style jsx>
          {`
            .ac-assets-size {
              padding: 0;
              ${Config.isIllustAC()
                ? `display: flex;
              justify-content: space-between;
              align-items: center;`
                : ''}
            }
            .ac-assets-size .assets-size-item {
              display: flex;
              align-items: center;
              padding: 8px 10px;
              cursor: pointer;
              user-select: none;

              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              /* identical to box height, or 175% */

              color: #000000;
            }
            .vertical-line {
              border-left: 1px solid #170507;
              height: 44px;
            }
            .ac-assets-size .assets-size-item .type-item {
              padding: 0 4px;
              min-width: 32px;
              height: 42px;
              font-weight: bold;
              font-size: 16px;
              white-space: nowrap;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              ${Config.isIllustAC()
                ? `font-weight: 700;
                   line-height: 28px;`
                : `color: #fff; 
                background: #1b2833;`}
            }
            .ac-assets-size .assets-size-item .type-item:hover,
            .ac-assets-size .assets-size-item-active .type-item {
              background: ${Config.isIllustAC()
                ? 'none'
                : themeVariables.colors.primary};
            }
            .ac-assets-size .assets-size-item .type-item.design_ac {
              margin-right: 4px;
            }
            .ac-assets-size .assets-size-item .type-item.illust_ac {
              min-width: 52px;
              margin-right: 4px;
            }
            .ac-assets-size .assets-size-item .size-item {
              text-align: center;
              flex-grow: 2;
              flex-basis: 0;
            }
            .ac-assets-size .assets-size-item .file-size {
              text-align: center;
              flex-grow: 1;
              flex-basis: 0;
            }
            .ac-assets-size .assets-size-item .asset-price {
              text-align: center;
              flex-grow: 1;
              flex-basis: 0;

              font-weight: 500;
              font-size: 16px;
              line-height: 28px;
              /* identical to box height, or 175% */

              color: #000000;
            }
            .ac-assets-size .assets-size-item-active {
              ${Config.isIllustAC() ? '' : 'background: #e6e7e9;'}
              border-radius: 2px;
            }
            .ac-assets-size .assets-actions {
              margin-top: 7px;
            }
            .ac-assets-size .btn-download-asset {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .ac-assets-size .assets-size-item .type-item {
                height: 27px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
});
export default connect(mapStateToProps)(AssetsSize);
